module.exports = __webpack_public_path__ + "static/media/mapbox-token-create.1fb32336.png";